<template>

    <div style="position: absolute;width: 100%;bottom: 0;top: 0;background-repeat: no-repeat;background-size: cover" :style="{backgroundImage:'url('+require('../assets/bg.png')+')'}">


        <div class="box" style="text-align: center">

            <img ref="img" style="width: 90%;vertical-align: middle"/>

            <div v-if="isWx" style="color: white;text-align: center;font-size: 14px;margin-top: 5px">长按保存证书</div>
        </div>


    </div>
    
</template>

<script>

    export default {
        name: "Certificate",

        data(){


            return{

                download:false,
                isWx:false,
            }
        },

        created(){


            let orderNo = this.$route.query.orderNo||this.$route.query.out_trade_no
            let id = this.$route.query.id;

            if(!orderNo){

                this.$toast('非法访问')
            }

           let toast =  this.$toast.loading({
                mask: true,
                message: '加载中...'
            });
            let image = new Image();

            image.src = this.$http.baseUrl+"/GZFPOneMeters/GetCertByOrderNo?OrderNo="+orderNo+"&ActId="+id
            let that = this;
            image.onload=function(){

                that.$refs.img.src=image.src

                toast.clear();
                that.is_wx();
            }

        },

        methods:{

            //判断是否微信客户端
            is_wx(){

                let ua = navigator.userAgent.toLowerCase();

                this.isWx = ua.match(/MicroMessenger/i) == "micromessenger";
            },



    }



    }
</script>

<style scoped>



    .btn{


        width: 100%;
        color: white;
        background-color: rgba(157, 42, 50, 1);
        position: fixed;
        bottom: 0;
        text-align: center;
    }


    .box{

        display: flex;
        flex-direction: column;
        height: 100%;
        align-items:center;
        justify-content:center;

    }

</style>